
import { Options, Vue } from 'vue-class-component';
import { mapGetters } from 'vuex';
import icon18plus from '@/base-components/icon18plus.vue';

@Options({
  components: { icon18plus },
  computed: {
    ...mapGetters(['getJsonData']),
    jsonData() {
      const jsonData = (this as any).getJsonData;
      const jsonDataWithBreaks = JSON.stringify(jsonData).replace(/\\n/g, '<br>');
      return JSON.parse(jsonDataWithBreaks);
    },
    buildDate() {
      const raw = process.env.VUE_APP_BUILD_DATE;
      if (!raw) return '';
      const date = new Date(raw);
      const formatted = date.toISOString().slice(0, 16).replace('T', ' ');
      return `v.${formatted}`;
    }
  }
})
export default class FooterView extends Vue {}
